import { render } from "./PrenotazioneAutomezzoDetail.vue?vue&type=template&id=495e380e&scoped=true"
import script from "./PrenotazioneAutomezzoDetail.vue?vue&type=script&lang=js"
export * from "./PrenotazioneAutomezzoDetail.vue?vue&type=script&lang=js"

import "./PrenotazioneAutomezzoDetail.vue?vue&type=style&index=0&id=495e380e&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495e380e"]])

export default __exports__